var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommerceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.7113C2.5 9.21612 3.10298 8.29977 4.35079 7.60535L9.48734 4.7468C12.1789 3.24893 13.5246 2.5 15 2.5C16.4754 2.5 17.8211 3.24893 20.5127 4.7468L25.6492 7.60535C26.897 8.29977 27.5 9.21612 27.5 10.7113C27.5 11.1168 27.5 11.3195 27.4557 11.4862C27.2231 12.3618 26.4297 12.5 25.6634 12.5H4.3366C3.57034 12.5 2.7769 12.3618 2.54428 11.4862C2.5 11.3195 2.5 11.1168 2.5 10.7113Z",
    stroke: "#2177FE",
    strokeWidth: 1.88
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9919 8.75H15.0032",
    stroke: "#2177FE",
    strokeWidth: 2.0017,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.499V23.124M10 12.499V23.124",
    stroke: "#2177FE",
    strokeWidth: 1.88
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.499V23.124M25 12.499V23.124",
    stroke: "#2177FE",
    strokeWidth: 1.88
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.125H6.25C4.17893 23.125 2.5 24.8039 2.5 26.875C2.5 27.2202 2.77982 27.5 3.125 27.5H26.875C27.2202 27.5 27.5 27.2202 27.5 26.875C27.5 24.8039 25.8211 23.125 23.75 23.125Z",
    stroke: "#2177FE",
    strokeWidth: 1.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerceActive);
export default __webpack_public_path__ + "static/media/commerceActive.5f6b1599295474dbdbae94f5f87fe170.svg";
export { ForwardRef as ReactComponent };